(function () {
  const BREAKPOINT = 749;

  function initFooterAccordions() {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    footer.querySelectorAll('.footer-block__heading').forEach(function (heading) {
      if (heading.dataset.accordionInit) return;
      heading.dataset.accordionInit = 'true';

      const content = heading.parentElement
        ? heading.parentElement.querySelector('.footer-block__details-content')
        : null;
      if (!content) return;

      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', 'false');

      function isMobile() {
        return window.innerWidth <= BREAKPOINT;
      }

      function toggle() {
        if (!isMobile()) return;
        const expanded = heading.getAttribute('aria-expanded') === 'true';
        heading.setAttribute('aria-expanded', String(!expanded));
        heading.parentElement.classList.toggle('is-open', !expanded);
      }

      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', function (event) {
        if (event.code === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          toggle();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordions);
  } else {
    initFooterAccordions();
  }

  document.addEventListener('shopify:section:load', initFooterAccordions);
})();
